import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { useContent } from "@/context/ContentContext";

export const Header = () => {
    const c = useContent();
    const h = c.header || {};
    const [open, setOpen] = useState(false);
    const loc = useLocation();
    useEffect(() => { setOpen(false); }, [loc.pathname]);

    const links = [
        { to: "/", label: h.nav_home || "Home" },
        { to: "/products", label: h.nav_catalog || "Catalog" },
        { to: "/about", label: h.nav_about || "About" },
        { to: "/contact", label: h.nav_contact || "Contact" },
    ];

    return (
        <header className="sticky top-0 z-50 bg-white border-b border-gray-200" data-testid="site-header">
            <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
                <Link to="/" data-testid="logo-link" className="block">
                    <Logo className="h-10 w-auto" />
                </Link>

                <nav className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            data-testid={`nav-${l.to.replace(/\W+/g, '') || 'home'}`}
                            className={({ isActive }) =>
                                `font-mono text-[11px] uppercase tracking-[0.22em] transition-colors ${
                                    isActive ? "text-red-600" : "text-gray-900 hover:text-red-600"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden md:flex items-center gap-4">
                    <Link to="/contact" className="btn-primary" data-testid="header-cta">
                        {h.cta_label || "Request Quote"}
                    </Link>
                </div>

                <button
                    className="md:hidden p-2"
                    onClick={() => setOpen((v) => !v)}
                    data-testid="mobile-menu-toggle"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-gray-200 bg-white" data-testid="mobile-menu">
                    <nav className="flex flex-col px-6 py-6 gap-5">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                end={l.to === "/"}
                                className={({ isActive }) =>
                                    `font-mono text-xs uppercase tracking-[0.22em] ${
                                        isActive ? "text-red-600" : "text-gray-900"
                                    }`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <Link to="/contact" className="btn-primary w-fit">
                            {h.cta_label || "Request Quote"}
                        </Link>
                    </nav>
                </div>
            )}
        </header>
    );
};
